import { render, staticRenderFns } from "./JoinTerms.vue?vue&type=template&id=e644eba4&scoped=true"
import script from "./JoinTerms.vue?vue&type=script&lang=js"
export * from "./JoinTerms.vue?vue&type=script&lang=js"
import style0 from "./JoinTerms.vue?vue&type=style&index=0&id=e644eba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e644eba4",
  null
  
)

export default component.exports